import React, { lazy } from "react";
import PrivateRoute from "../../components/PrivateRoute";
import { Routes } from "../../context/App";
import HelpThankYou from "../../components/HelpThankyou";

const HelpPage = lazy(() => import("../../pages/HelpPage"));

interface HelpPageProps {
  route: typeof Routes.HELPPAGE;
  path: string;
  exact: boolean;
}

const HelpPageRoute: React.FC<HelpPageProps> = (props) => {
  const { route, path, exact } = props;
  return (
    <PrivateRoute
      path={path}
      route={route}
      exact={exact}
      Component={HelpPage}
    />
  );
};

export default HelpPageRoute;
